module.exports = __webpack_public_path__ + "img/4.42940d5c.png";